export default "__VITE_ASSET__CURonbEs__"